/* @flow */
export default {
  DATE_FORMAT: '{{timestamp, date}}',
  DATETIME_FORMAT: '{{timestamp, datetime}}',
  SAVE: 'Salva',
  CANCEL: 'Annulla',
  NAME: 'Nome',
  NOTES: 'Note',
  USERNAME: 'Username',
  DESCRIPTION: 'Descrizione',
  PASSWORD: 'Password',
  LOGIN: 'Accedi',
  FORGOT_PASSWORD: 'Password dimenticata...',
  LOADING: 'Caricamento in corso',
  NO_VALUE_AVAILABLE: 'Nessun valore disponibile',
  NO_VALUE: 'Nessun valore',
  SHOW_MORE: 'Mostra di più...',
  SELECT_A_VALUE: 'Seleziona un valore...',
  PRODUCTION_NAME: 'Nome produzione',
  EDITION: 'Edizione',
  AREA: 'Area',
  PRODUCER_NAME: 'Ente produttore',
  CHANNEL: 'Canale',
  BROADCASTER: 'Emittente',
  PLATFORM_CHANNEL: 'Canale di distribuzione',
  BROADCAST_TYPE: 'Tipologia emissione',
  PRODUCTION_TYPE: 'Tipologia produzione',
  USAGE_TYPE: 'Tipologia utilizzo',
  PRODUCTION: 'Produzione',
  EPISODE: 'Puntata',
  START_LICENSE_DATE: 'Inizio licenza',
  END_LICENSE_DATE: 'Fine licenza',
  TERRITORY: 'Territorio',
  PUBLISHER_OR_DISTRIBUTOR: 'Distributore o Emittente',
  QUANTITY_SUPPORT: 'Quantità (supporti/puntate)',
  DISTRIBUTION_CHANNEL_OR_MEDIA: 'Canale di distribuzione/Media e Piattaforma o Emittente',
  LOAD_PRESET: 'Carica preset',
  USAGE_QUANTITY: 'Quantità (supporti/puntate)',
  CART: 'Carrello',
  EMPTY_CART: 'Carrello vuoto',
  TRACK: 'Traccia',
  TRACKS: 'Tracce',
  TOTAL_PRICE_ELEMENTS: 'Prezzo totale elementi acquistabili',
  DISCOUNTS_OR_INCREASES: 'Sconti cumulativi o maggiorazioni',
  NET_PRICE_ELEMENTS: 'Prezzo totale netto elementi selezionati',
  BUY: 'Acquista',
  IN_CART: 'Nel carrello',
  SEARCH_SUPPORTS: 'Cerca supporti',
  SEARCH_TRACKS: 'Cerca tracce',
  SEARCH_SERVICES: 'Servizi On Demand',
  NEWS: 'Novità',
  SMARTLISTS: 'Smartlist',
  FEATURED: 'Vetrine',
  ON_DEMAND: 'On Demand',
  ON_DEMAND_SERVICES: 'Servizi On Demand',
  SUPPORTS: 'Supporti',
  LOGOUT: 'Logout',
  PURCHASE_HISTORY: 'Storico acquisti',
  WORKLIST: 'Worklist',
  USAGE: 'Utilizzi',
  PRODUCTIONS: 'Produzioni',
  PROFILE: 'Sistema',
  PROFILE_SETTINGS: 'Impostazioni',
  REPORT: 'Output',
  INFO: 'Info',
  PRICE_LISTS: 'Listini',
  TUTORIAL: 'Tutorial',
  HELP: 'Assistenza',
  SESSION_USAGE: 'Utilizzo di sessione',
  CATEGORIES: 'Categorie',
  UNKNOWN_ARTIST: 'Interprete sconosciuto',
  SELECT_A_WL1: 'Seleziona una Worklist 1',
  SELECT_A_WL2: 'Seleziona una Worklist 2',
  SELECT_A_SESSION_USAGE: 'Seleziona un utilizzo di sessione',
  TRACK_NOT_DOWNLOADABLE:
    'Impossibile iniziare lo scaricamento, devono essere prima acquistati gli opportuni componenti di licenza',
  PERFORMER: 'Interprete',
  PERFORMERS: 'Interpreti',
  SUPPORT_TITLE: 'Titolo supporto',
  TITLE: 'Titolo',
  TITLES: 'Titoli',
  PEOPLE: 'Persone',
  TAG: 'Tag',
  AUTHOR: 'Autore',
  AUTHORS: 'Autori',
  TAGS: 'Tags',
  EDITORS: 'Editori',
  LABEL: 'Etichetta',
  YEAR: 'Anno',
  RESET_FILTERS: 'Annulla filtri',
  PRODUCTION_DESCRIPTION: 'Spiegazione produzione',
  DEFINE_NEW_PRODUCTION: 'Definisci nuova produzione',
  DEFINE_NEW_USAGE: 'Definisci nuovo usage',
  SELECT_AS_USAGE_SESSION: 'Seleziona come Utilizzo di sessione',
  USAGE_DESCRITPION: 'Spiegazione usage',
  ARE_YOU_SURE: 'Sei sicuro?',
  SELECTED_AS_WL1: 'Selezionato come Worklist 1',
  SELECTED_AS_WL2: 'Selezionato come Worklist 2',
  SELECT_AS_WL1: 'Seleziona come Worklist 1',
  SELECT_AS_WL2: 'Seleziona come Worklist 2',
  DEFINE_NEW_WORKLIST: 'Definisci nuova worklist',
  SEARCH: 'Cerca',
  GENERIC_ERROR: 'Errore generico',
  NO_RESULT: 'Nessun risultato',
  NO_ARTIST: 'Nessun artista',
  YOU_SEARCHED: 'Hai cercato',
  ANY: 'Qualsiasi',
  SORTED_BY: 'Ordinato per',
  YOU_HAVE_FOUND: 'Hai trovato',
  ONE_SUPPORT: 'Un supporto',
  ONE_NEWS: 'Una news',
  SUPPORT: 'Supporto',
  NO_PERFORMER: 'Nessun interprete',
  NO_AUTHOR: 'Nessun autore',
  PLAYING: 'In riproduzione',
  PAUSE: 'Pausa',
  PLAY: 'Play',
  ALBUM_COVER: 'Copertina album',
  OPERA: 'Opera',
  CATALOG: 'Catalogo',
  METRE: 'Metro',
  TEMPO: 'Tempo',
  ORCHESTRATION: 'Strumenti',
  BPM: 'BPM',
  GENRE: 'Genere',
  TONES: 'Tonalita',
  ANY_TRACK: 'Qualsiasi traccia',
  ALL_CATEGORIES: 'Tutte le categorie',
  IN_CATEGORIES: 'Nelle categorie',
  ONE_TRACK: 'Una traccia',
  QUOTATION: 'Quotazione,',
  SMARTLIST: 'Smartlist',
  DATE: 'Data',
  ONDEMAND_TYPE: 'Tipo di richiesta',
  TRACK_TITLE: 'Titolo traccia',
  REQUEST_TITLE: 'Titolo richiesta',
  QUOTATION_TITLE: 'Titolo quotazione',
  SMARTLIST_TITLE: 'Titolo smartlist',
  SUBMIT: 'Invia',
  WORKLISTS: 'Worklist',
  ELEMENTS: 'Elementi',
  MODIFIED_DATE: 'Ultima modifica',
  WORKLIST_COVER: 'Copertina worklist',
  WRITE_REQUEST: 'Scrivici una richiesta',
  CREATE_DATE: 'Data di creazione',
  ITEMS_COUNT: 'Numero di elementi',
  USAGE_TAB_1: 'Riepilogo',
  USAGE_TAB_2: 'Licenza',
  USAGE_TAB_3: 'Note',
  EXCLUSIVE: 'Esclusiva',
  NO_PRODUCTION_TYPE: 'Nessuna tipologia produzione',
  NO_USAGE_TYPE: 'Nessuna tipologia utilizzo',
  NO_BROADCAST_TYPE: 'Nessuna tipologia emissione',
  NO_PRODUCTION: 'Nessuna produzione',
  NO_EPISODE: 'Nessun episodio',
  NO_PLATFORM: 'Nessun canale di distribuzione',
  NO_START_LICENSE_DATE: 'Nessuna data inizio licenza',
  NO_END_LICENSE_DATE: 'Nessuna data fine licenza',
  YES: 'Sì',
  NO: 'No',
  EMPTY_WORKLIST: 'Worklist vuota',
  DETAILS: 'Dettagli',
  PUBLISH: 'Pubblica',
  ARCHIVE: 'Archivia',
  DELETE: 'Elimina',
  NO_OPTIONS_AVAILABLE: 'Nessuna opzione disponibile',
  NO_OPTION_SELECTED: 'Nessuna opzione selezionata',
  EXCLUDE_PRODUCTION_MUSIC: 'Escludi Production music',
  MORE_TRACKS: 'Più tracce...',
  RELEVANCE: 'Rilevanza',
  DURATION: 'Durata',
  PRICE: 'Prezzo',
  ALBUM: 'Album',
  SINGLES: 'Singoli',
  COMPILATION: 'Compilation',
  SOUNDTRACK: 'Soundtrack',
  PRODUCTION_MUSIC: 'Production Music',
  CLASSIC_MUSIC: 'Musica Classica',
  DANCE_MUSIC: 'Electronic Music',
  NO_PURCHASES: 'Nessun acquisto',
  SAVE_AS_PRESET: 'Salva come preset',
  NO_TRACK_TO_PLAY: 'Nessuna traccia da riprodurre',
  SHOW_PLAYLIST: 'Mostra playlist',
  CREATE_NEW_PRODUCTION: 'Crea nuova produzione',
  USAGE_NAME: 'Nome utilizzo',
  USAGE_PRESET_NAME: 'Nome preset di utilizzo',
  NO_DESCRIPTION: 'Nessuna descrizione',
  ASK_NEW_SMARTLIST: 'Richiedi nuova smartlist',
  ASK_NEW_TRACK: 'Richiedi nuova traccia',
  ASK_QUOTATION: 'Richiedi quotazione',
  PURCHASE_DATE: 'Data acquisto',
  CONFIRM_EXIT_DIRTY_FORM:
    'Stai per cambiare pagina ma potresti avere modifiche non salvate. Vuoi procedere?',
  EXCLUSIVE_NOTES: 'Note esclusiva',
  NEW_WORKLIST: 'nuova worklist',
  ADD_TO: 'Aggiungi a',
  DOWNLOAD: 'Scarica',
  RESET: 'Reset',
  LICENSE_COMPONENTS: 'Componenti di licenza',
  RIGHT: 'Diritto',
  DISCOUNTED_PRICE: 'Prezzo scontato',
  TOTAL_PRICE_PURCHASED_ELEMENTS: 'Prezzo totale elementi acquistati',
  SENT_TO_CART_DATE: 'Data invio a carrello',
  NO_COMPONENTS:
    'Non è possibile calcolare i relativi componenti di licenza con le attuali impostazioni di utilizzo',
  CATEGORY: 'Categoria',
  GO_TO_WORKLIST: 'Vai alla worklist',
  BASES: 'Basi Musicali',
  CANNOT_BUY: 'Non acquistabile',
  USAGE_DETAILS: 'Dettaglio utilizzi',
  I_CONSENT: 'Acconsento',
  COOKIE_BANNER:
    'Utilizziamo dei cookies per migliorare l’esperienza d’uso del sito web. Continuando la navigazione accetti la nostra informativa sui cookies.',
  DEMO: 'Demo',
  LEGAL_OFFICE: 'Sede legale',
  REGISTERED_CAPITAL: 'Capitale sociale',
  LEGAL_NOTES: 'Note legali',
  PURCHASE_MISSING_COMPONENTS:
    'Un componente di licenza non è stato inviato a Carrello perché non quotato',
  COLLECTING: 'Collecting',
  COMING_SOON: 'Coming soon',
  TRY_SMARTLISTS: 'Provate le raccolte tematiche che operatori esperti preparano per voi!',
  FILTERS: 'Filtri',
  CREATE: 'Crea',
  NO_USAGE_PRESETS_AVAILABLE: 'Nessun preset di utilizzo disponibile',
  NO_USAGE_PRESET_SELECTED: 'Seleziona un preset di utilizzo',
  USE_SEARCH_HELPER_1: 'Per avviare una ricerca puoi utilizzare il campo apposito',
  USE_SEARCH_HELPER_2: 'a inizio pagina',
  EDIT: 'Modifica',
  LOCKED: 'Bloccato',
  UNLOCKED: 'Sbloccato',
  PREVIOUS_TRACK: 'Traccia precedente',
  NEXT_TRACK: 'Traccia successiva',
  PAUSED: 'In pausa',
  MUTE_VOLUME: 'Silenzia volume',
  UNMUTE_VOLUME: 'Attiva volume',
  ASK_REQUEST: 'Fai una richiesta',
  REFRESH: 'Aggiorna',
  ADD: 'Aggiungi',
  COLLAPSE: 'Collassa',
  EXPAND: 'Espandi',
  SEARCH_TITLES: 'Ricerca tra i titoli',
  SEARCH_TAGS: 'Ricerca tra i tag',
  SEARCH_PEOPLE: 'Ricerca tra persone (autori, interpreti, etc.)',
  SHOW_LESS: 'Mostra di meno',
  USAGE_PRESETS: 'Preset di utilizzi',
  CREATE_NEW_USAGE_PRESET: 'Crea un nuovo preset di utilizzo',
  COPY_AS_USAGE_PRESET: 'Copia questo utilizzo in un nuovo preset',
  SELECT_THIS_USAGE_PRESET: 'Seleziona questo preset di utilizzo',
  SELECT_A_USAGE_PRESET: 'Clicca per selezionare un preset di utilizzo',
  MUSIC_BASES: 'Basi musicali',
  YOU_SEARCHED_QUERY:
    '{{resultsCount}} {{resultsType}} per "{{searchString}}", ordinati per {{ordering}}, in {{categories}} e',
  SEND_TO_WORKLIST_BEFORE_BUY: "Per effettuare l'acquisto occorre salvare l'item in una Worklist",
  ITEMS_TO_CHECKOUT_NEED_USAGE:
    "Ci sono elementi pronti per l'acquisto ma prima occorre definirne un utilizzo",
  DO_YOU_CONFIRM_PURCHASE: 'Gli elementi selezionati verranno acquistati. Vuoi procedere?',
  YOU_SEARCHED_NEWS: '{{resultsCount}} {{resultsType}} in {{categories}}',
};
